var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftIcon = function SvgGiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.6 0h-.023l-.023.001a1.82 1.82 0 0 0-1.735 1.89A1.78 1.78 0 0 0 4.64 3.42H2.076A1.45 1.45 0 0 0 .69 4.889v2.96a1.45 1.45 0 0 0 .81 1.374v5.06a1.45 1.45 0 0 0 1.386 1.467h10.248a1.45 1.45 0 0 0 1.386-1.467v-5.07a1.45 1.45 0 0 0 .79-1.364v-2.96a1.45 1.45 0 0 0-1.386-1.467l-.022-.001h-2.614a1.79 1.79 0 0 0 .912-1.515v-.012A1.82 1.82 0 0 0 10.47.051c-.877-.045-1.528.4-1.946.857a4 4 0 0 0-.525.732 4 4 0 0 0-.497-.716C7.092.457 6.46 0 5.6 0M9 9.37h3.52v4.38H9zm0-2h4.31V5.42H9zM7 5.42v1.95H2.69V5.42zm0 3.95v4.38H3.5V9.37z",
    clipRule: "evenodd"
  })));
};
export default SvgGiftIcon;